import { render } from "./AtorCSU.vue?vue&type=template&id=7ec94082&scoped=true"
import script from "./AtorCSU.vue?vue&type=script&lang=js"
export * from "./AtorCSU.vue?vue&type=script&lang=js"

import "./AtorCSU.vue?vue&type=style&index=0&id=7ec94082&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec94082"]])

export default __exports__